module.exports = __webpack_public_path__ + "static/img/DJ.08711689.svg";